/** The find-free flows' one toast after "book now" (#401): a warning only when the booking waits for approval. */
import { toast } from "sonner";
import { pendingWarning } from "@/lib/booking-approvals";

export function warnIfPending(booked: Parameters<typeof pendingWarning>[0]): void {
  const message = pendingWarning(booked);
  if (message) toast.warning(message);
}
